import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/default-labs/lab-company/style'

/** API */
import LabCompaniesApi from 'api/setting/default-labs/lab-company.api'

/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'


const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  LAB_COMPANY_NAME: ``,
  IS_DUPLICATE_LAB_COMPANY_NAME: ``,
  LAB_COMPANY_NAME_STRING_BASE: ``,
  LAB_COMPANY_NAME_STRING_EMPTY: ``,
  LAB_COMPANY_NAME_MAXIMUM_LENGTH: ``,
  LAB_COMPANY_NAME_ANY_REQUIRED: ``,

  LAB_COMPANY_NAME_EN: ``,
  IS_DUPLICATE_LAB_COMPANY_NAME_EN: ``,
  LAB_COMPANY_NAME_EN_STRING_BASE: ``,
  LAB_COMPANY_NAME_EN_STRING_EMPTY: ``,
  LAB_COMPANY_NAME_EN_MAXIMUM_LENGTH: ``,
  LAB_COMPANY_NAME_EN_ANY_REQUIRED: ``
}
export default function LabCompany() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [labCompanies, setLabCompanies] = useState([])

  const [labCompanyId, setLabCompanyId] = useState(Number)
  const [labCompanyName, setLabCompanyName] = useState('')
  const [labCompanyNameEn, setLabCompanyNameEn] = useState('')
  const [labCompanyStatus, setLabCompanyStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isPopup, setIsPopup] = useState(false)

  const loadData = async () => {
    try {
      const resp = await LabCompaniesApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setLabCompanies(resp.data)
      } else {
        setLabCompanies([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!labCompanyName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ LAB_COMPANY_NAME: t('LAB_COMPANY.MESSAGE.LAB_COMPANY_NAME') } })
    }
    dispatch(submitModal())

    LabCompaniesApi.create({ labCompanyName, labCompanyNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('LAB_COMPANY.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`LAB_COMPANY.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`LAB_COMPANY.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!labCompanyName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ LAB_COMPANY_NAME: t(`LAB_COMPANY.MESSAGE.LAB_COMPANY_NAME`) } })
    }
    dispatch(submitModal())
    LabCompaniesApi.update(labCompanyId, { labCompanyName, labCompanyNameEn, status: labCompanyStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`LAB_COMPANY.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`LAB_COMPANY.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`LAB_COMPANY.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setLabCompanyId(0)
    setLabCompanyName('')
    setLabCompanyNameEn('')
    setLabCompanyStatus('')
    clearErrorMessage()
    setIsPopup(false)
  }

  const onActive = () => {
    if (id) {
      LabCompaniesApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('LAB_COMPANY.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('LAB_COMPANY.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      LabCompaniesApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('LAB_COMPANY.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('LAB_COMPANY.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { labCompanyId: lcId, labCompanyName: lcName, labCompanyNameEn: lcNameEn, status: lcStatus } = data
    setLabCompanyId(lcId)
    setLabCompanyName(lcName)
    setLabCompanyNameEn(lcNameEn)
    setLabCompanyStatus(lcStatus)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'labCompanyName', disablePadding: false, label: t('LAB_COMPANY.TABLE.CELL.LAB_COMPANY_NAME') },
    { id: 'labCompanyNameEn', disablePadding: false, label: t('LAB_COMPANY.TABLE.CELL.LAB_COMPANY_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('LAB_COMPANY.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('LAB_COMPANY.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { labCompanyId: lcId, labCompanyName: lcName, labCompanyNameEn: lcNameEn, updatedBy, updatedAt, status: lcStatus } = objData
    const statusBtnActive = lcStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = lcStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: lcId,
      id: lcId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: lcName },
        { option: 'TEXT', align: 'left', label: lcNameEn },
        { option: 'STATUS', align: 'center', label: lcStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.labCompanyName)
    setNameEn(obj.labCompanyNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`LAB_COMPANY.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`LAB_COMPANY.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { labCompanyName: name, labCompanyNameEn: nameEn && `(${nameEn})`, status: t(`LAB_COMPANY.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={labCompanyId ? t('LAB_COMPANY.TITLE_UPDATE') : t('LAB_COMPANY.TITLE_CREATE')}
        isOpen={isPopup}
        onCancel={{ onClick: () => resetForm() }}
        onSubmit={{ onClick: () => labCompanyId ? submitEdit() : submit(), disabled: disabledSubmit }}
        handleClose={resetForm}
        size={'XS'}
      >
        <Box paddingY="8px">
          {labCompanyId ? (
            <Box display="flex" justifyContent="space-between" alignItems="center" paddingBottom="8px">
              <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
              <SwitchButton
                onChange={() => setLabCompanyStatus(labCompanyStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                checked={labCompanyStatus === 'ACTIVE' ? true : false}
              />
            </Box>
          ) : (
            ''
          )}

          <Box display={'flex'} flexDirection={'column'} gap={'24px'}>
            <TextInput
              fullWidth
              onChange={(event) => {
                setLabCompanyName(event.target.value)
                clearErrorMessage()
              }}
              value={labCompanyName}
              label={t('LAB_COMPANY.INPUT.LAB_COMPANY_NAME')}
              helperText={
                errorMessage.LAB_COMPANY_NAME ||
                errorMessage.IS_DUPLICATE_LAB_COMPANY_NAME ||
                errorMessage.LAB_COMPANY_NAME_STRING_BASE ||
                errorMessage.LAB_COMPANY_NAME_STRING_EMPTY ||
                errorMessage.LAB_COMPANY_NAME_MAXIMUM_LENGTH ||
                errorMessage.LAB_COMPANY_NAME_ANY_REQUIRED
              }
              required={true}
            />
            <TextInput
              fullWidth
              onChange={(event) => {
                setLabCompanyNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={labCompanyNameEn}
              helperText={
                errorMessage.LAB_COMPANY_NAME_EN ||
                errorMessage.IS_DUPLICATE_LAB_COMPANY_NAME_EN ||
                errorMessage.LAB_COMPANY_NAME_EN_STRING_BASE ||
                errorMessage.LAB_COMPANY_NAME_EN_STRING_EMPTY ||
                errorMessage.LAB_COMPANY_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.LAB_COMPANY_NAME_EN_ANY_REQUIRED
              }
              label={t('LAB_COMPANY.INPUT.LAB_COMPANY_NAME_EN')}
              required={false}
            />
          </Box>
        </Box>
      </PageModal>
      <HeaderCard text={t('LAB_COMPANY.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('LAB_COMPANY.SEARCH')}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton title={t('LAB_COMPANY.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsPopup(true)} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={labCompanies.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
